import { SprievodnyDokumentAddApi } from 'evidencna-aplikacia-frontend-ts-axios';
import {
  evidenciaPrefixPath,
} from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import SprievodnyDokumentRequest from '../../../model/pracovnyKrok/SprievodnyDokumentRequest';
import ApiConfiguration from '../../configuration/apiConfiguration';
import Uuid from '../../../model/Uuid';

const client = new SprievodnyDokumentAddApi(ApiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createSprievodnyDokument = async (
  request: SprievodnyDokumentRequest,
  stadiumUuid: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.addSprievodnyDokument(
    request.legMaterialUuid,
    stadiumUuid,
    request.typDokumentu,
    request.sprievodnyDokument,
    headers,
  );
  return {
    responseCode: status,
  };
};
